module.exports = __webpack_public_path__ + "static/media/responsabilidad.416f9139.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/responsabilidad.svg
// module id = 191
// module chunks = 0